import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../icon/Icon';
import styles from './notes.module.css';
export function ConsequenceNote({ text }) {
    return (_jsxs("p", { className: styles.consequence, children: [_jsx(Icon, { name: "unsure", className: styles.consequenceIcon }), _jsx("span", { children: text })] }));
}
//# sourceMappingURL=ConsequenceNote.js.map